import { useCallback, useMemo } from 'react';
import { Button } from 'reactstrap';
import {
    APIProvider, Map as GoogleMap,
} from '@vis.gl/react-google-maps';
import { PanTo } from '../../common/Map/usePanTo.hook';
import { GoogleSearch } from '../../common/Map/GoogleSearch';
import { MapMarkers } from './MapMarkers';

const DEFAULT_ZOOM = 12.2;

export const EmployeeMap = ({
    employees, center, apiKey, mapId,
    onCenterChange, baseCenter, selectedEmployeeId, warningMessage, onWarningClose,
}) => {
    const mapCenter = useMemo(() => {
        if (center) {
            const lat = Number(center.lat), lng = Number(center.lng);

            if (Number.isFinite(lat) && Number.isFinite(lng)) {
                return { lat, lng };
            }
        }

        return center;
    }, [center]);

    const handleAutocompleteCenter = useCallback((place) => {
        if (!place) {
            onCenterChange({ lat: baseCenter.lat, lng: baseCenter.lng, place: null });
            return;
        }
        const loc = place.location;

        if (!loc) {
            return;
        }

        onCenterChange({ lat: loc.lat(), lng: loc.lng(), place });
    }, [onCenterChange, baseCenter]);

    return (
        <APIProvider
            apiKey={apiKey}
            libraries={['marker', 'places']}
        >
            <GoogleMap
                mapId={mapId}
                defaultCenter={mapCenter}
                defaultZoom={DEFAULT_ZOOM}
                options={{
                    mapTypeControl: false,
                    streetViewControl: false,
                    clickableIcons: false,
                    styles: [
                        { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
                        { featureType: 'landscape', elementType: 'labels', stylers: [{ visibility: 'off' }] },
                        { featureType: 'landscape.natural', elementType: 'labels', stylers: [{ visibility: 'off' }] },
                        { featureType: 'administrative', elementType: 'labels', stylers: [{ visibility: 'off' }] },
                        { featureType: 'transit', elementType: 'labels', stylers: [{ visibility: 'off' }] },
                        { featureType: 'transit.station', elementType: 'all', stylers: [{ visibility: 'off' }] },
                        { featureType: 'water', elementType: 'labels', stylers: [{ visibility: 'off' }] },
                    ],
                }}
            >
                <PanTo target={mapCenter} />

                <GoogleSearch
                    onPlaceSelect={handleAutocompleteCenter}
                    selectedPlace={center?.place}
                />

                <MapMarkers
                    employees={employees}
                    selectedEmployeeId={selectedEmployeeId}
                />

                <div className={`map-warning-overlay${warningMessage ? ' show' : ''}`}>
                    {warningMessage}
                    <Button
                        close
                        onClick={onWarningClose}
                    />
                </div>
            </GoogleMap>
        </APIProvider>
    );
};